import { Component, Input } from '@angular/core';
import { ManualAddressDto } from '@shared/src/controllers/maps/ManualAddressDto';
import { MapMarcadorDto, MapPuntDto, MapService } from '@shared/src/services/map/map.service';
import { MapsController } from '../../controllers/maps/maps.controller';
import { HString } from '../../datatypes/HString';

@Component({
  selector: 'shared-map-address-component',
  templateUrl: './shared.map.address.component.html',
  styleUrls: ['./shared.map.address.component.scss']
})
export class SharedMapAddressComponent {

  constructor(private mapsController: MapsController) {
  }

  private _addressData: ManualAddressDto | null = null;
  @Input()
  public set addressData(value: ManualAddressDto) {
    if (this._addressData === value)
      return;
    this._addressData = value;
    this.resolveAddressData();
  }
  public get addressData(): ManualAddressDto | null {
    return this._addressData;
  }

  private resolveAddressData() {
    if (!this._addressData) {
      this.punt = null;
      return;
    }
    const lat = this._addressData.latitude;
    const lon = this._addressData.longitude;
    if (lat != null && lon != null && lat !== -1 && lon !== -1) {
      this.punt = MapPuntDto.builder(lon, lat);
    } else if (!HString.isNullOrNullString(this._addressData.formattedAddress)) {
      this.mapsController.resolveaddress(this._addressData.formattedAddress).subscribe(value => {
        if (value != null)
          this.punt = MapPuntDto.builder(value.longitude, value.latitude);
        else
          this.punt = null;
      });
    } else {
      this.punt = null;
    }
  }

  public viewMode: 'map' | 'fields' = 'map';

  public copyToClipboard() {
    if (this._addressData?.formattedAddress)
      navigator.clipboard.writeText(this._addressData.formattedAddress);
  }

  public get coordinatesText(): string {
    if (this._punt == null) return '';
    return `${this._punt.latitude}, ${this._punt.longitude}`;
  }

  public zoom: number = MapService.DEFAULT_GOOGLEMAPS_ADDRESS_ZOOM;
  public longitude: number = MapService.DEFAULT_LONGITUDE;
  public latitude: number = MapService.DEFAULT_LATITUDE;
  public marcadors: Array<MapMarcadorDto> = new Array<MapMarcadorDto>();

  private _punt: MapPuntDto | null = null;
  public set punt(value: MapPuntDto | null) {
    if (this._punt === value)
      return;
    this._punt = value;
    this.calculate();
  }
  public get punt(): MapPuntDto | null {
    return this._punt;
  }

  private calculate() {
    if (this._punt == null) {
      this.longitude = MapService.DEFAULT_LONGITUDE;
      this.latitude = MapService.DEFAULT_LATITUDE;
      this.marcadors = new Array<MapMarcadorDto>();
      return;
    }
    this.longitude = this._punt.longitude;
    this.latitude = this._punt.latitude;
    this.marcadors = [MapMarcadorDto.builder(this._punt.longitude, this._punt.latitude).adreça()];
  }
}
